import ReactEcharts from "echarts-for-react";
import _ from "lodash";
import { DateTime, Interval } from "luxon";
import { Event, FShift } from "../../../../../types/types";
import { EquipmentTimelineData, PersonTimelineData } from "../../../../../stores/TabsStore";
import { hexColor, rgbColor } from "../../../../../enums/colors";
import { useMemo } from "react";
import { getCurrentStateColor } from "../../../../../lib/calculations";

// 0: "equipment_item_id"
// 1: "event_date"
// 2: "shift_date"
// 3: "start"
// 4: "start_ts"
// 5: "finish"
// 6: "finish_ts"
// 7: "duration"
// 8: "state"
// 9: "equipment_item_status"
// 10: "personnel_id"
// 11: "equipment_item_division_id"
// 12: "personnel_division_id"
// 13: "state_changed"
// 14: "status_changed"
// 15: "person_changed"

const TimelineChart = ({events, shift, from, to, personId, height, width}: {events: Event[]; shift: FShift; from: DateTime, to: DateTime, personId: number, height: string | number; width: string | number;}) => {
  const start_date = DateTime.fromSQL(String(events[0][3]));
  const end_date = DateTime.fromSQL(String(events[events.length - 1][3]));

  const start = DateTime.fromObject({
    year: start_date.year,
    month: start_date.month,
    day: start_date.day,
    hour: shift.start_at.hour,
    minute: shift.start_at.minute,
    second: shift.start_at.second,
  });

  const end = DateTime.fromObject({
    year: end_date.year,
    month: end_date.month,
    day: shift.start_at > shift.end_at ? start_date.plus({days: 1}).day : start_date.day,
    hour: shift.end_at.hour,
    minute: shift.end_at.minute,
    second: shift.end_at.second,
  });

  const intervals = [
    Interval.fromDateTimes(start, end)
      .splitBy({ hour: 1 })
      .map((d) => d.start?.toISOTime({ includeOffset: false, suppressMilliseconds: true })),
    end.toISOTime({ includeOffset: false, suppressMilliseconds: true }),
  ].flat();
  const shiftDuration = end.toSeconds() - start.toSeconds();

  const chartData = useMemo(() => {
    return events.map((item) => (
      {
        name: item[8],
        type: "bar",
        stack: "timeline",
        color: Number(item[4]) >= from.toSeconds() && Number(item[6]) <= to.toSeconds() && Number(item[10]) === personId ? getCurrentStateColor(String(item[8])) : getCurrentStateColor("turned_off"),
        data: [item[7]]
      }
    ))
  }, [events, from, to])

  const getOptions = () => ({
    tooltip: { show: false },
    grid: {
      left: "0%",
      right: "0%",
      bottom: -5,
      top: -5,
      containLabel: false,
    },
    animation: false,
    xAxis: [
      { show: false, max: shiftDuration },
      { show: false, data: intervals },
    ],
    yAxis: { show: false, type: "category" },
    series: chartData,
  });

  return <ReactEcharts option={getOptions()} notMerge={true} style={{ height: height, width: width }} opts={{ renderer: "canvas" }} />;
};

export default TimelineChart;